// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"23":"fd7d3d17","160":"54a642c9","208":"f3af3f1e","293":"1fc30c85","453":"e18caccd","516":"b276a0c1","519":"b9a5478e","917":"4513e642","946":"ce116f07"}[chunkId] + ".chunk.js";
};